<template>
    <VJoyText preset="primary-200" class="answer-time-indicator">
        <VJoyIcon name="clock" color="neutral-50" size="xsmall" />
        {{ $t('profile.header.indicators.answer.time.label') }} {{ $t(`profile.stats.response.time.${averageAnswerTimeCode}` as TranslationKey) }}
    </VJoyText>
</template>

<script setup lang="ts">
    import {VJoyIcon, VJoyText} from '@maltjoy/core-vue';
    import type {TranslationKey} from '#build/i18n';

    defineProps<{
        averageAnswerTimeCode: string;
    }>();
</script>

<style scoped lang="scss">
    .answer-time-indicator {
        /* !important to prevent content layout shift */
        display: flex !important;
        align-items: center !important;
        gap: var(--joy-core-spacing-1) !important;
    }
</style>
